import { render, staticRenderFns } from "./NewsAiTag.vue?vue&type=template&id=34098b6c&"
import script from "./NewsAiTag.vue?vue&type=script&lang=js&"
export * from "./NewsAiTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports